import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchProgram, fetchMemberCategoriesByBusinessUnit, addProgramMemberCategory } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function ProgramMemberCategoryAddPage() {
  const { businessDomainId, businessUnitId, programId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const basePath = `/strategy/${businessDomainId}/business-units/${businessUnitId}/programs/${programId}`;

  const [available, setAvailable] = useState([]);
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const [program, all] = await Promise.all([
          fetchProgram(programId),
          fetchMemberCategoriesByBusinessUnit(businessUnitId),
        ]);
        const assigned = new Set((program.associatedMemberCategories || []).map((c) => c.memberCategoryId));
        setAvailable((Array.isArray(all) ? all : []).filter((c) => !assigned.has(c.memberCategoryId)));
      } catch (e) { notify.apiError(e); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programId, businessUnitId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedId) { notify.error(t("common.selectRequired")); return; }
    try {
      await addProgramMemberCategory(programId, selectedId);
      notify.success(t("message.create.success"));
      navigate(`${basePath}/member-categories`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("program.memberCategory.add.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <FormControl fullWidth required>
              <InputLabel>{t("memberCategory.name")}</InputLabel>
              <Select value={selectedId} onChange={(e) => setSelectedId(e.target.value)}
                label={t("memberCategory.name")}>
                {available.map((c) => (
                  <MenuItem key={c.memberCategoryId} value={c.memberCategoryId}>
                    {c.memberCategoryName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.add")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}/programs/${programId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
